export const commissionRoute = {
  COMMISSION_LIST: '/commission/list',
  COMMISSION_DETAIL: '/commission/detail/:recordId',
};
